import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import config from "@/client-config.js";
import "@/assets/theme.css";

if ("scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}

const app = createApp(App);
app.config.globalProperties.$config = config;
app.use(router).use(vuetify).mount("#app");

router.isReady().then(() => {
  window.scrollTo({ left: 0, top: 0, behavior: "auto" });
});
